let _initProto, _initClass, _init_position, _init_extra_position, _init_duration, _init_extra_duration, _init_visibleToasts, _init_extra_visibleToasts, _init_closeButton, _init_extra_closeButton, _init_expand, _init_extra_expand, _init_gap, _init_extra_gap, _init_offset, _init_extra_offset, _init_container, _init_extra_container, _init_toasts, _init_extra_toasts;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { jsx } from "@ecopages/jsx/jsx-runtime";
import { RadiantElement, bound, customElement, onEvent, onUpdated, prop, state } from "@ecopages/radiant";
import { DEFAULT_TOAST_POSITION, RUI_TOAST_DISMISS_EVENT, RUI_TOAST_SHOW_EVENT, TOAST_COLLAPSED_PEEK, TOAST_GAP, TOAST_LIFETIME, TOAST_VIEWPORT_OFFSET, TOAST_VISIBLE_AMOUNT, TOAST_WIDTH, splitToastPosition } from "./toast-context";
import { collapsedStackHeight, expandedStackHeight, expandedToastOffset } from "./stack-layout";
import { toastState } from "./toast-state";
import "./toast.script";
function isInsideToaster(node, root) {
  return node instanceof Node && root.contains(node);
}
let _RuiToaster;
class RuiToaster extends RadiantElement {
  static {
    ({
      e: [_init_position, _init_extra_position, _init_duration, _init_extra_duration, _init_visibleToasts, _init_extra_visibleToasts, _init_closeButton, _init_extra_closeButton, _init_expand, _init_extra_expand, _init_gap, _init_extra_gap, _init_offset, _init_extra_offset, _init_container, _init_extra_container, _init_toasts, _init_extra_toasts, _initProto],
      c: [_RuiToaster, _initClass]
    } = _applyDecs(this, [customElement("rui-toaster")], [[prop({
      type: String,
      reflect: true,
      defaultValue: DEFAULT_TOAST_POSITION
    }), 0, "position"], [prop({
      type: Number,
      defaultValue: TOAST_LIFETIME
    }), 0, "duration"], [prop({
      type: Number,
      defaultValue: TOAST_VISIBLE_AMOUNT
    }), 0, "visibleToasts"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "closeButton"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "expand"], [prop({
      type: Number,
      defaultValue: TOAST_GAP
    }), 0, "gap"], [prop({
      type: Number,
      defaultValue: TOAST_VIEWPORT_OFFSET
    }), 0, "offset"], [prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "container"], [state, 0, "toasts"], [onUpdated(["position", "duration", "visibleToasts", "closeButton", "expand", "gap", "offset", "container"]), 2, "onConfigUpdated"], [onEvent({
      document: true,
      type: RUI_TOAST_SHOW_EVENT
    }), 2, "onDocumentShow"], [onEvent({
      document: true,
      type: RUI_TOAST_DISMISS_EVENT
    }), 2, "onDocumentDismiss"], [onEvent({
      selector: "rui-toast",
      type: "rui-toast-mounted"
    }), 2, "onToastMounted"], [bound, 2, "onPointerOver"], [bound, 2, "onPointerOut"], [bound, 2, "onPointerDown"], [bound, 2, "onPointerUp"]], 0, void 0, RadiantElement));
  }
  position = (_initProto(this), _init_position(this));
  duration = (_init_extra_position(this), _init_duration(this));
  visibleToasts = (_init_extra_duration(this), _init_visibleToasts(this));
  closeButton = (_init_extra_visibleToasts(this), _init_closeButton(this));
  expand = (_init_extra_closeButton(this), _init_expand(this));
  gap = (_init_extra_expand(this), _init_gap(this));
  offset = (_init_extra_gap(this), _init_offset(this));
  container = (_init_extra_offset(this), _init_container(this));
  toasts = (_init_extra_container(this), _init_toasts(this, []));
  expanded = (_init_extra_toasts(this), false);
  interacting = false;
  unsubscribe = null;
  visibilityHandler = null;
  heights = /* @__PURE__ */new Map();
  observers = /* @__PURE__ */new Map();
  layoutFrame = null;
  /** Prevents ResizeObserver re-entry while temporarily unclipping hosts to measure. */
  measuring = false;
  connectedCallback() {
    super.connectedCallback();
    this.syncHostPosition();
    this.syncContainer();
    this.unsubscribe = toastState.subscribe(toasts => {
      this.toasts = toasts;
      if (toasts.length === 0) {
        this.resetLayoutState();
      }
      this.scheduleLayoutSync();
    });
    this.visibilityHandler = () => this.syncPauseState();
    document.addEventListener("visibilitychange", this.visibilityHandler);
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    this.unsubscribe = null;
    if (this.visibilityHandler) {
      document.removeEventListener("visibilitychange", this.visibilityHandler);
      this.visibilityHandler = null;
    }
    document.removeEventListener("pointerup", this.onPointerUp);
    document.removeEventListener("pointercancel", this.onPointerUp);
    if (this.layoutFrame != null) cancelAnimationFrame(this.layoutFrame);
    this.resetLayoutState();
    super.disconnectedCallback();
  }
  onConfigUpdated() {
    this.syncHostPosition();
    this.syncContainer();
    this.scheduleLayoutSync();
  }
  onDocumentShow(event) {
    const detail = event.detail;
    if (!detail?.title) return;
    toastState.create(detail.title, {
      id: detail.id,
      description: detail.description,
      variant: detail.variant,
      duration: detail.duration,
      action: detail.action,
      dismissible: detail.dismissible,
      closeButton: detail.closeButton,
      position: detail.position
    });
  }
  onDocumentDismiss(event) {
    const detail = event.detail;
    toastState.dismiss(detail?.id);
  }
  onToastMounted() {
    this.scheduleLayoutSync();
  }
  filteredToasts() {
    const forPosition = this.toasts.filter(toast => (toast.position ?? this.position) === this.position);
    const active = [];
    const exiting = [];
    for (const toast of forPosition) {
      if (toast.delete) exiting.push(toast);else active.push(toast);
    }
    return [...active.slice(0, this.visibleToasts), ...exiting];
  }
  syncHostPosition() {
    const {
      y,
      x
    } = splitToastPosition(this.position);
    this.dataset.yPosition = y;
    this.dataset.xPosition = x;
    this.style.setProperty("--width", `${TOAST_WIDTH}px`);
    this.style.setProperty("--gap", `${this.gap}px`);
    this.style.setProperty("--viewport-offset", `${this.offset}px`);
  }
  /**
   * Bind the toaster to a positioning root when `container` is set.
   *
   * @remarks
   * Prefers an ancestor match so nested demos do not reparent. Only appends
   * into a query-selected root when the toaster is not already inside it.
   * Contained mode uses absolute positioning; default mode restores viewport fixed.
   */
  syncContainer() {
    const selector = this.container.trim();
    if (!selector) {
      this.removeAttribute("data-contained");
      this.style.position = "";
      return;
    }
    const target = this.closest(selector) ?? document.querySelector(selector);
    if (!target) {
      this.removeAttribute("data-contained");
      this.style.position = "";
      return;
    }
    if (getComputedStyle(target).position === "static") {
      target.style.position = "relative";
    }
    if (!target.contains(this)) {
      target.appendChild(this);
    }
    this.dataset.contained = "true";
    this.style.position = "absolute";
  }
  isStackExpanded() {
    return this.expanded || this.expand;
  }
  /**
   * @remarks
   * Pause only while the pointer is interacting / hovering, or the tab is
   * hidden. The `expand` prop is visual-only — it must not freeze lifetimes.
   */
  isPaused() {
    return this.expanded || this.interacting || document.hidden;
  }
  resetLayoutState() {
    for (const observer of this.observers.values()) observer.disconnect();
    this.observers.clear();
    this.heights.clear();
    this.expanded = false;
    this.interacting = false;
    const list = this.querySelector(".rui-toaster");
    if (list) {
      list.style.height = "0px";
      list.dataset.expanded = "false";
    }
    this.dataset.expanded = "false";
  }
  syncPauseState() {
    const paused = this.isPaused();
    for (const el of this.querySelectorAll("rui-toast")) {
      el.setPaused(paused);
    }
    this.patchStackLayout();
  }
  /**
   * Measure + layout on the next frame. Re-reads `:hover` because emptying the
   * stack under the cursor can skip `pointerout`, leaving hold/expand stale.
   */
  scheduleLayoutSync() {
    if (this.layoutFrame != null) cancelAnimationFrame(this.layoutFrame);
    this.layoutFrame = requestAnimationFrame(() => {
      this.layoutFrame = null;
      if (this.toasts.length > 0 && !this.interacting) {
        const list = this.querySelector(".rui-toaster");
        const hovered = Boolean(list?.matches(":hover") || this.matches(":hover"));
        this.expanded = hovered;
      }
      this.observeToasts();
      this.syncPauseState();
    });
  }
  /**
   * Natural content height for stack math.
   *
   * @remarks
   * Uses the inner `.rui-toast` `offsetHeight` (layout size, transform-independent).
   * Host height/overflow are temporarily cleared because collapsed behind toasts are
   * clipped to the front height — leaving that in place can under-measure in some engines.
   */
  measureToast(el) {
    this.measuring = true;
    const prevHeight = el.style.height;
    const prevOverflow = el.style.overflow;
    el.style.height = "auto";
    el.style.overflow = "visible";
    const inner = el.querySelector(".rui-toast");
    const height = Math.round(inner instanceof HTMLElement ? inner.offsetHeight : el.offsetHeight) || 64;
    el.style.height = prevHeight;
    el.style.overflow = prevOverflow;
    this.measuring = false;
    return height;
  }
  observeToasts() {
    const list = this.querySelector(".rui-toaster");
    if (!list) return;
    const els = [...list.querySelectorAll("rui-toast")];
    const seen = /* @__PURE__ */new Set();
    for (const el of els) {
      const id = el.toastId;
      if (!id) continue;
      seen.add(id);
      const target = el.querySelector(".rui-toast") ?? el;
      if (!this.observers.has(id)) {
        const observer = new ResizeObserver(() => {
          if (this.measuring) return;
          const height = this.measureToast(el);
          if (this.heights.get(id) === height) return;
          this.heights.set(id, height);
          this.patchStackLayout();
        });
        observer.observe(target);
        this.observers.set(id, observer);
      }
      this.heights.set(id, this.measureToast(el));
    }
    for (const [id, observer] of [...this.observers]) {
      if (seen.has(id)) continue;
      observer.disconnect();
      this.observers.delete(id);
      this.heights.delete(id);
    }
  }
  /**
   * @remarks
   * Expanded offsets use each toast's natural height (Sonner formula):
   * `sum(heights before) + index * gap`. Collapsed mode peeks at most
   * {@link TOAST_COLLAPSED_PEEK} toasts with scale; overflow stays
   * mounted but hidden until hover expands the stack.
   * Heights are always remeasured — clipped collapsed hosts make caches stale.
   */
  patchStackLayout() {
    const list = this.querySelector(".rui-toaster");
    if (!list) return;
    const expanded = this.isStackExpanded();
    const {
      y
    } = splitToastPosition(this.position);
    const lift = y === "bottom" ? -1 : 1;
    const peekLimit = Math.min(TOAST_COLLAPSED_PEEK, Math.max(1, this.visibleToasts));
    this.dataset.expanded = String(expanded);
    list.dataset.expanded = String(expanded);
    this.style.setProperty("--lift", String(lift));
    list.style.setProperty("--gap", `${this.gap}px`);
    const els = [...list.querySelectorAll("rui-toast")].filter(el => el.dataset.mounted === "true" && el.dataset.removed !== "true");
    if (els.length === 0) {
      list.style.height = "0px";
      return;
    }
    const heights = els.map(el => {
      const measured = this.measureToast(el);
      this.heights.set(el.toastId, measured);
      return measured;
    });
    const frontHeight = heights[0] ?? 64;
    this.style.setProperty("--front-toast-height", `${frontHeight}px`);
    for (let index = 0; index < els.length; index += 1) {
      const el = els[index];
      if (!el) continue;
      const height = heights[index] ?? 64;
      const isFront = index === 0;
      const offset = expandedToastOffset(index, heights, this.gap);
      const inCollapsedPeek = index < peekLimit;
      el.dataset.index = String(index);
      el.dataset.front = String(isFront);
      el.dataset.expanded = String(expanded);
      el.dataset.visible = String(expanded || inCollapsedPeek);
      el.style.setProperty("--z-index", String(els.length - index));
      el.style.setProperty("--index", String(index));
      el.style.setProperty("--offset", `${offset}px`);
      el.style.setProperty("--initial-height", `${height}px`);
      el.style.setProperty("--gap", `${this.gap}px`);
      if (expanded) {
        el.style.setProperty("--y", `translateY(${lift * offset}px)`);
        el.style.height = `${height}px`;
        el.style.overflow = "visible";
      } else if (!inCollapsedPeek) {
        el.style.setProperty("--y", `translateY(${lift * (peekLimit - 1) * this.gap}px) scale(0.7)`);
        el.style.height = `${frontHeight}px`;
        el.style.overflow = "hidden";
      } else if (isFront) {
        el.style.setProperty("--y", "translateY(0px)");
        el.style.height = `${height}px`;
        el.style.overflow = "visible";
      } else {
        const scale = Math.max(0.7, 1 - index * 0.05);
        el.style.setProperty("--y", `translateY(${lift * index * this.gap}px) scale(${scale})`);
        el.style.height = `${frontHeight}px`;
        el.style.overflow = "hidden";
      }
    }
    const collapsedPeekCount = Math.min(peekLimit, els.length);
    list.style.height = `${expanded ? expandedStackHeight(heights, this.gap) : collapsedStackHeight(frontHeight, collapsedPeekCount, this.gap)}px`;
  }
  onPointerOver(event) {
    if (isInsideToaster(event.relatedTarget, this)) return;
    this.expanded = true;
    this.syncPauseState();
  }
  onPointerOut(event) {
    if (isInsideToaster(event.relatedTarget, this)) return;
    if (this.interacting) return;
    this.expanded = false;
    this.syncPauseState();
  }
  onPointerDown() {
    this.interacting = true;
    this.expanded = true;
    this.syncPauseState();
    document.addEventListener("pointerup", this.onPointerUp, {
      once: true
    });
    document.addEventListener("pointercancel", this.onPointerUp, {
      once: true
    });
  }
  onPointerUp() {
    if (!this.interacting) return;
    this.interacting = false;
    const list = this.querySelector(".rui-toaster");
    const hovered = Boolean(list?.matches(":hover") || this.querySelector("rui-toast:hover"));
    if (!hovered) this.expanded = false;
    this.syncPauseState();
  }
  render() {
    const filtered = this.filteredToasts();
    return /* @__PURE__ */jsx("section", {
      class: "rui-toaster-region",
      "aria-label": "Notifications",
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false",
      tabIndex: -1,
      children: /* @__PURE__ */jsx("ol", {
        class: "rui-toaster",
        "data-rui-toaster": true,
        "on:pointerover": this.onPointerOver,
        "on:pointerout": this.onPointerOut,
        "on:pointerdown": this.onPointerDown,
        children: filtered.map(toast => {
          const duration = toast.duration ?? (toast.variant === "loading" ? Number.POSITIVE_INFINITY : this.duration);
          return /* @__PURE__ */jsx("rui-toast", {
            "prop:toastId": String(toast.id),
            "prop:title": toast.title,
            "prop:description": toast.description ?? "",
            "prop:variant": toast.variant,
            "prop:duration": duration,
            "prop:dismissible": toast.dismissible,
            "prop:closeButton": toast.closeButton ?? this.closeButton,
            "prop:actionLabel": toast.action?.label ?? "",
            "prop:position": toast.position ?? this.position,
            "prop:markedDelete": Boolean(toast.delete)
          }, String(toast.id));
        })
      })
    });
  }
  static {
    _initClass();
  }
}
export { _RuiToaster as RuiToaster };